export const Data = [
{
    id: 1, 
    category: "education", 
    icon:"icon-graduation",
    year:"June 2023 - August 2023",
    title: "Logistics officer - Assistance Publique – Hôpitaux de Paris (France)",
    desc:"Reception and sorting of linen (sheets, blankets, pillowcases, towels) after washing",
    desc1:"Counting, recording and dispatching linen (sheets, blankets, pillowcases, towels) to delivery lorries"
   
},

    {
    id: 2,
    category:"education",
    icon:"icon-graduation",
    year: "May 2023",
    title: "Inventor - RGIS (France)", 
    desc:"Gather information on the assigned perimeter using a barcode reader",
    desc1:"Data entry and transfer to inventory software"
    },

    ];
    